import { Nullable } from "./utils/nullable";
import { isNullOrUndefined } from "src/common/utils";

export const CANCELLED_REASONS = {
  CalledApiAgain: "Called api again. hence cancelled this call",
};

export const NOT_LOADED_STATE = "Not loaded yet";

export type dispatchFnType = (resetApi: Boolean) => void;
export class ApiCallState {
  isApiCalled: Boolean;
  isApiCallFailed: Boolean;
  isApiCallLoading: Boolean;
  isApiCallCompletedSuccessfully: Boolean;
  dispatchApiCall: dispatchFnType;

  constructor(
    isApiCalled: Boolean,
    isApiCallFailed: Boolean,
    isApiCallLoading: Boolean,
    isApiCallCompletedSuccessfully: Boolean,
    dispatchApiCall: dispatchFnType
  ) {
    this.isApiCalled = isApiCalled;
    this.isApiCallFailed = isApiCallFailed;
    this.isApiCallLoading = isApiCallLoading;
    this.isApiCallCompletedSuccessfully = isApiCallCompletedSuccessfully;
    this.dispatchApiCall = dispatchApiCall;
  }
}

export function isApiCalled(progress: Nullable<String>): Boolean {
  return progress !== NOT_LOADED_STATE;
}

export function isApiCallLoading(progress: Nullable<String>): Boolean {
  return !isNullOrUndefined(progress) && progress !== NOT_LOADED_STATE;
}

export function isApiCallFailed(error: Nullable<unknown>): Boolean {
  return !isNullOrUndefined(error);
}

export function isApiCallCompletedSuccessfully(
  progress: Nullable<String>,
  error: Nullable<unknown>
): Boolean {
  return isNullOrUndefined(progress) && isNullOrUndefined(error);
}

export class ApiCallStatusV2 {
  isCalled: Boolean;
  isFailed: Boolean;
  isLoading: Boolean;
  isCompletedSuccessfully: Boolean;

  constructor(progress: string | null, error: string | null) {
    this.isCalled = isApiCalled(progress);
    this.isFailed = isApiCallFailed(error);
    this.isLoading = isApiCallLoading(progress);
    this.isCompletedSuccessfully = isApiCallCompletedSuccessfully(progress, error);
  }
}
